const defaultVoteItemActivation = ['like', 'dislike', 'broken', 'comment'];

export default defaultVoteItemActivation;
